import Vue from 'vue'
import Router from 'vue-router'
import templateList from '@/components/templateList'
import Main from '@/components/main'
import templateEdit from '@/components/templateEdit'


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'templateList',
      component: templateList,
      meta: {
        keepalive: false
      }
    },
    {
      path: '/Main',
      name: 'Main',
      component: Main,
      meta: {
        keepalive: true
      }
    },
    {
      path: '/templateEdit',
      name: 'templateEdit',
      component: templateEdit,
      meta: {
        keepalive: true
      }
    }
  ]
})




// WEBPACK FOOTER //
// ./src/router/index.js